import { ICriticalContainerError, ContainerErrorType } from '@fluidframework/container-definitions';
import { OWHErrorType } from '@fluidx/office-fluid-types';

export function isContainerGenericError(error: ICriticalContainerError) {
  return error.errorType === ContainerErrorType.genericError;
}

export function isContainerThrottlingError(error: ICriticalContainerError) {
  return error.errorType === ContainerErrorType.throttlingError;
}

/**
 * Returns value indicating whether given error object indicates that container version is no longer valid and upgrade is required.
 * @param error Error object
 *
 * TODO: Consider promoting ContainerUpgradeRequired to FF and expose it via ErrorType
 */
export function isContainerUpgradeRequiredError(error: ICriticalContainerError) {
  return (
    error.errorType === ContainerErrorType.genericError &&
    (error as any).error?.name === OWHErrorType.ContainerUpgradeRequired
  );
}

/**
 * Match a error against known fluid container error types
 * @param error potential container error
 * @returns ContainerErrorType in case of a match
 */
export function tryMatchContainerErrorType(
  error: unknown
): ContainerErrorType | OWHErrorType.ContainerUpgradeRequired | undefined {
  if (typeof error === 'object') {
    const typedError = error as ICriticalContainerError;

    if (isContainerGenericError(typedError)) {
      if (isContainerUpgradeRequiredError(typedError)) {
        return OWHErrorType.ContainerUpgradeRequired;
      }

      return ContainerErrorType.genericError;
    }

    // Should warnings be handled distinctly from errors?
    if (isContainerThrottlingError(typedError)) {
      return ContainerErrorType.throttlingError;
    }

    // ... try match any other known container error types
  }

  return;
}
